// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__1eYRZ","shimmer":"Loading_shimmer__wXamq","light":"Loading_light__zYgGJ"};